<template>
	<div v-show="isActive" class="tab__content">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'DefaultTab',

	props: {
		name: { type: String, required: true },
		selected: { type: Boolean, default: false },
		icon: { type: String, required: true },
		gtm: { type: String, required: false, default: null },
		ga4: { type: String, required: false, default: null },
	},

	data() {
		return {
			isActive: false,
		};
	},
	mounted() {
		this.isActive = this.selected;
	},
	methods: {},
};
</script>

<style lang="scss">
.tab__content {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	@include tablet {
		flex-direction: row;
	}

	.ticket-grid & {
		justify-content: center;

		& .masonry-column {
			flex-grow: 1;
		}
	}
}
</style>
